import { Button } from '@usealloy/component-library';
import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';

import UploadedDocument from '~/documents/UploadedDocument';


const DocumentListModalPropTypes = {
  documents: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  displayTrigger: PropTypes.bool,
  customLabel: PropTypes.string,
  customTitle: PropTypes.string,
  caseDocuments: PropTypes.bool,
  changeStatus: PropTypes.bool,
  entityToken: PropTypes.string,
  onDocumentNameChange: PropTypes.func,
  hasPermissionToEdit: PropTypes.bool,
};

const DocumentListModalDefaultProps = {
  displayTrigger: true,
  customLabel: null,
  customTitle: null,
  caseDocuments: false,
  changeStatus: true,
  hasPermissionToEdit: true,
};

const StyledHeader = styled.h2`
  margin-left: 20px;
`;

const DocumentListModal = ({
  documents,
  isOpen,
  toggleModal,
  displayTrigger,
  customLabel,
  customTitle,
  caseDocuments,
  changeStatus,
  entityToken,
  onDocumentNameChange,
  hasPermissionToEdit,
}) => {
  const handleOpenModal = () => {
    toggleModal('document-list');
  };

  const handleCloseModal = () => {
    toggleModal();
  };

  const docs = documents.filter(d => {
    if (caseDocuments) {
      return Boolean(d.case_token);
    }
    return !d.case_token;
  });
  if (docs.length === 0) {
    return null;
  }
  return (
    <div key="document-list-modal">
      {displayTrigger && (
        <a
          className={`secondary ${docs.length ? '' : 'disabled'}`}
          onClick={docs.length ? handleOpenModal : () => {}}
        >
          {`${customLabel || 'Documents'} `}({docs.length})
        </a>
      )}

      <Modal
        id="document-list-modal"
        isOpen={isOpen}
        toggle={toggleModal}
      >
        <div className="modal-header">
          <Button className="close" onClick={toggleModal}>
            <i className="far fa-fw fa-times" />
          </Button>
        </div>
        <ModalBody>
          <div className="row header-40">
            <div className="col">
              <StyledHeader>{customTitle || 'Documents'}</StyledHeader>
            </div>
          </div>

          <div className="document-list">
            {docs.map(doc => (
              <UploadedDocument
                key={doc.document_token}
                doc={doc}
                reviewCallback={handleCloseModal}
                changeStatus={changeStatus}
                entityToken={entityToken}
                onDocumentNameChange={onDocumentNameChange}
                hasPermissionToEdit={hasPermissionToEdit}
              />
            ))}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button onClick={toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

DocumentListModal.propTypes = DocumentListModalPropTypes;
DocumentListModal.defaultProps = DocumentListModalDefaultProps;

export default DocumentListModal;
